import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = ({ size }: any) => {
  return <CircularProgress color="primary" size={size} />;
};

export default Spinner;
